module.exports = __webpack_public_path__ + "static/logo-mobile-94a175d79b9a2e59050bfef268ca7db4.svg";